import { Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl5')} ${spacing('md')} 0 ${spacing('md')};
`;

export const StyledTabs = styled.div`
  display: block;
  flex-direction: row;
  gap: 2rem;
  margin-bottom: 4rem;

  @media (min-width: ${screen('lg')}) {
    display: flex;
  }
`;

export const StyledTab = styled.div<{
  active?: boolean;
}>`
  background-color: ${color('white')};
  border-radius: ${radius('lg')};
  box-shadow: ${shadow('md')};
  padding: ${spacing('md')};
  text-align: center;
  flex: 1 1 100%;
  margin-bottom: ${spacing('md')};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${screen('lg')}) {
    width: 50%;
    margin-bottom: 0;
    flex: 1 1 50%;
  }

  h3 {
    margin-bottom: 1.5rem;
  }

  img {
    display: block;
    max-width: 308px;
    margin: 0 auto ${spacing('md')} auto;
  }

  strong {
    display: block;
    font-size: ${fontSize('lg')};
    margin-bottom: ${spacing('md')};
  }
`;

export const StyledStep = styled.div<{
  visible: boolean;
}>`
  font-size: ${fontSize('lg')};
  display: flex;
  flex-direction: column-reverse;
  gap: 0rem;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    gap: 2rem;
  }

  li {
    list-style-type: disc;
    margin-left: 1.5rem;
  }

  img {
    width: 100%;
    height: auto;
    margin: 2rem auto;
    display: block;
  }

  > div:last-child {
    flex: 1 0 auto;
    max-width: 40%;
  }

  display: ${({ visible }) => (visible ? 'flex' : 'none')};
`;

export const StyledStepHead = styled.h4`
  font-family: ${fontFamily('sans-serif')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('xl')};
  line-height: 1.12;
  margin: 0;
`;

export const StyledHeader = styled.div`
  text-align: center;
  max-width: 58rem;
  margin: auto;
  line-height: 1.5;
  margin-bottom: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledFeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('mdlg')};
  margin-bottom: ${spacing('xl4')};

  @media (min-width: ${screen('lg')}) {
    gap: ${spacing('xl')};
  }
`;

export const StyledFeatureImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing('md')} ${spacing('md')} 0;

  @media (min-width: ${screen('lg')}) {
    justify-content: flex-start;
    padding: 0;
  }

  img {
    display: block;

    &.desktop {
      display: none;
    }

    @media (min-width: ${screen('lg')}) {
      width: 100%;

      &.mobile {
        display: none;
      }
      &.desktop {
        display: block;
      }
    }
  }
`;

export const StyledFeatureContent = styled.div`
  padding: 0 ${spacing('mdlg')} ${spacing('mdlg')};

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('xl2')} ${spacing('xl2')} ${spacing('xl2')} 0;
  }

  ${Heading3} {
    margin-top: ${spacing('md')};
  }
`;

export const StyledFeature = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing('md')};
  background-color: ${color('white')};
  border-radius: ${radius('lg')};
  box-shadow: ${shadow('md')};
  overflow: hidden;

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: ${spacing('xl')};
    font-size: ${fontSize('lg')};

    &:nth-of-type(odd) {
      ${StyledFeatureImage} {
        @media (min-width: ${screen('lg')}) {
          order: 1;
          justify-content: flex-end;
        }
      }

      ${StyledFeatureContent} {
        @media (min-width: ${screen('lg')}) {
          padding: ${spacing('xl2')} 0 ${spacing('xl2')} ${spacing('xl2')};
        }
      }
    }
  }
`;

export const StyledCta = styled.div`
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing('xl4')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    margin-bottom: ${spacing('md')};
  }

  p {
    line-height: 1.5;
    color: ${color('text_subtle')};
    margin-top: ${spacing('xs')};

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('lg')};
      line-height: 1.6;
    }
  }
`;
